// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.VideoCardList {
  display: grid;
  grid-template-columns: 36px 26px 142px 1fr 100px 100px 100px 100px;
  grid-column-gap: 16px;
  align-items: center;
  justify-items: left;
  cursor: pointer;
  font-size: 14px;
  padding: 8px;
  border-radius: 4px;
}
.VideoCardList:hover {
  background: #f5f7fb;
}
.VideoCardList .VideoCardList-index {
  font-size: 12px;
  color: var(--gray_dark1);
  justify-self: center;
}
.VideoCardList .VideoCardList-image {
  position: relative;
  width: 100%;
}
.VideoCardList .VideoCardList-image .VideoCardList-image-live-ads-wrapper {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 5px;
}
.VideoCardList .VideoCardList-image .VideoCardList-image-live-ads-wrapper .LivePostTag {
  margin-left: 5px;
}
.VideoCardList .VideoCardList-image .VideoCardList-image-live-ads-wrapper .YellowBadge-customStyle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.VideoCardList .VideoCardList-image .VideoCardList-image-live-ads-wrapper .YellowBadge-customStyle svg path {
  transform: translateX(20%);
}
.VideoCardList .VideoCardList-image img {
  border-radius: 4px;
  display: block;
  object-fit: cover;
}
.VideoCardList .VideoCardList-image .text-fallback {
  width: 142px;
  height: 96px;
  background-color: #f1f2fa;
  border-radius: 4px;
  font-size: 14px;
}
.VideoCardList .VideoCardList-title {
  line-height: 18px;
  color: var(--primary_dark2);
  margin: 0 0 4px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.VideoCardList .VideoCardList-creator {
  margin: 0 0 16px;
}
.VideoCardList .VideoCard-creator-popover {
  z-index: 2;
  bottom: 15px;
  position: absolute;
  width: 300px;
  left: 0;
  padding: 0 0 8px;
}
.VideoCardList .VideoCard-creator-popover-content {
  border: 1px solid var(--gray_light2);
  background: #fff;
  padding: 8px;
  border-radius: 4px;
}
.VideoCardList .VideoCardList-creator-content {
  display: flex;
  align-items: center;
  line-height: 18px;
}
.VideoCardList .VideoCardList-creator-content .CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee {
  width: 265px;
}
.VideoCardList .VideoCardList-provider {
  margin: 0 8px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.VideoCardList .VideoCardList-by {
  font-size: 12px;
  margin: 0 4px 0 0;
}
.VideoCardList .VideoCardList-creatorTitle {
  position: relative;
}
.VideoCardList .VideoCardList-creatorTitle-text {
  font-size: 12px;
  color: var(--color_primary_500);
}
.VideoCardList .VideoCardList-creatorTitle-text a {
  color: var(--color_primary_500);
}
.VideoCardList .VideoCardList-likes,
.VideoCardList .VideoCardList-views,
.VideoCardList .VideoCardList-comments,
.VideoCardList .VideoCardList-date {
  line-height: 18px;
  color: var(--primary_dark2);
}
.VideoCardList .VideoCardList-metric-label {
  font-size: 12px;
  line-height: 15px;
  color: var(--gray);
}
.VideoCardList .CreatorCard .CreatorCard-second-column .title {
  max-width: 180px;
}
.VideoCardList .checkbox {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/VideoCardList/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,kEAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAeF;AAbE;EACE,mBAAA;AAeJ;AAZE;EACE,eAAA;EACA,wBAAA;EACA,oBAAA;AAcJ;AAXE;EACE,kBAAA;EACA,WAAA;AAaJ;AAXI;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAaN;AAXM;EACE,gBAAA;AAaR;AAVM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAYR;AATU;EACE,0BAAA;AAWZ;AALI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AAON;AAJI;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAMN;AAFE;EACE,iBAAA;EACA,2BAAA;EACA,eAAA;EDpEF,oBAAA;EACA,aCoEsB;EDnEtB,qBCmEsB;EDlEtB,4BAAA;EACA,gBAAA;EACA,sBANoC;AC+EtC;AANE;EACE,gBAAA;AAQJ;AALE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;AAOJ;AAJE;EACE,oCAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAMJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAKJ;AAFM;EACE,YAAA;AAIR;AACE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,eAAA;EACA,+BAAA;AAFJ;AAII;EACE,+BAAA;AAFN;AAME;;;;EAIE,iBAAA;EACA,2BAAA;AAJJ;AAOE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AALJ;AASI;EACE,gBAAA;AAPN;AAWE;EACE,gBAAA;AATJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import '../../mixins';\n\n.VideoCardList {\n  display: grid;\n  grid-template-columns: 36px 26px 142px 1fr 100px 100px 100px 100px;\n  grid-column-gap: 16px;\n  align-items: center;\n  justify-items: left;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px;\n  border-radius: 4px;\n\n  &:hover {\n    background: #f5f7fb;\n  }\n\n  .VideoCardList-index {\n    font-size: 12px;\n    color: var(--gray_dark1);\n    justify-self: center;\n  }\n\n  .VideoCardList-image {\n    position: relative;\n    width: 100%;\n\n    .VideoCardList-image-live-ads-wrapper {\n      display: flex;\n      position: absolute;\n      z-index: 1;\n      top: 5px;\n      right: 5px;\n\n      .LivePostTag {\n        margin-left: 5px;\n      }\n\n      .YellowBadge-customStyle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        svg {\n          path {\n            transform: translateX(20%);\n          }\n        }\n      }\n    }\n\n    img {\n      border-radius: 4px;\n      display: block;\n      object-fit: cover;\n    }\n\n    .text-fallback {\n      width: 142px;\n      height: 96px;\n      background-color: #f1f2fa;\n      border-radius: 4px;\n      font-size: 14px;\n    }\n  }\n\n  .VideoCardList-title {\n    line-height: 18px;\n    color: var(--primary_dark2);\n    margin: 0 0 4px;\n    @include line-clamp(2);\n  }\n\n  .VideoCardList-creator {\n    margin: 0 0 16px;\n  }\n\n  .VideoCard-creator-popover {\n    z-index: 2;\n    bottom: 15px;\n    position: absolute;\n    width: 300px;\n    left: 0;\n    padding: 0 0 8px;\n  }\n\n  .VideoCard-creator-popover-content {\n    border: 1px solid var(--gray_light2);\n    background: #fff;\n    padding: 8px;\n    border-radius: 4px;\n  }\n\n  .VideoCardList-creator-content {\n    display: flex;\n    align-items: center;\n    line-height: 18px;\n\n    .CreatorCardOnHover {\n      .CreatorCardFetcher .CreatorCardMiniWithTolgee {\n        width: 265px;\n      }\n    }\n  }\n\n  .VideoCardList-provider {\n    margin: 0 8px 0 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .VideoCardList-by {\n    font-size: 12px;\n    margin: 0 4px 0 0;\n  }\n\n  .VideoCardList-creatorTitle {\n    position: relative;\n  }\n\n  .VideoCardList-creatorTitle-text {\n    font-size: 12px;\n    color: var(--color_primary_500);\n\n    a {\n      color: var(--color_primary_500);\n    }\n  }\n\n  .VideoCardList-likes,\n  .VideoCardList-views,\n  .VideoCardList-comments,\n  .VideoCardList-date {\n    line-height: 18px;\n    color: var(--primary_dark2);\n  }\n\n  .VideoCardList-metric-label {\n    font-size: 12px;\n    line-height: 15px;\n    color: var(--gray);\n  }\n\n  .CreatorCard .CreatorCard-second-column {\n    .title {\n      max-width: 180px;\n    }\n  }\n\n  .checkbox {\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
